module.exports = __webpack_public_path__ + "static/media/gmaps-tutorial.503fac28.png";